/**
 * Frankfurter v1 (ECB rates).
 *
 * - **Never** use `api.frankfurter.app` from the browser — responses omit CORS
 *   headers, so `fetch` fails from `https://sisuforge.com` and similar origins.
 * - **Dev** (`npm start`): same-origin `/__frankfurter__` → `setupProxy.js` →
 *   `https://api.frankfurter.dev/v1/...` (no CORS).
 * - **Production build**: direct `https://api.frankfurter.dev/v1` (public API allows
 *   browser access per project docs). Override with `REACT_APP_FRANKFURTER_BASE`
 *   if you front it with your own proxy.
 */
export function priceApiBaseFrankfurter(): string {
  const fromEnv = process.env.REACT_APP_FRANKFURTER_BASE?.trim();
  if (fromEnv) return fromEnv.replace(/\/$/, '');

  if (process.env.NODE_ENV === 'development') {
    return '/__frankfurter__';
  }
  return 'https://api.frankfurter.dev/v1';
}
